// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"price_priceContainer__dXtI9","wasPrice":"price_wasPrice__lY87n"};